module.exports = __webpack_public_path__ + "static/media/img96.8cb6019c.jpg";